// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AcademiaRouteImport } from './routes/academia'
import { Route as AlunoRouteImport } from './routes/aluno'
import { Route as AtendimentoParaAltoVolumeDeContatosRouteImport } from './routes/atendimento-para-alto-volume-de-contatos'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AutomacaoComercialRouteImport } from './routes/automacao-comercial'
import { Route as AutomacaoComercialParaEmpresasRouteImport } from './routes/automacao-comercial-para-empresas'
import { Route as AutomacaoComercialParaGrandesEmpresasRouteImport } from './routes/automacao-comercial-para-grandes-empresas'
import { Route as AutomacaoDeAtendimentoAoClienteRouteImport } from './routes/automacao-de-atendimento-ao-cliente'
import { Route as AutomacaoDeFollowUpRouteImport } from './routes/automacao-de-follow-up'
import { Route as AutomacaoDeVendasPeloWhatsappRouteImport } from './routes/automacao-de-vendas-pelo-whatsapp'
import { Route as ConsultoriaDeAutomacaoComercialRouteImport } from './routes/consultoria-de-automacao-comercial'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as CriacaoDeSitesRouteImport } from './routes/criacao-de-sites'
import { Route as CriarContaRouteImport } from './routes/criar-conta'
import { Route as CrmParaWhatsappRouteImport } from './routes/crm-para-whatsapp'
import { Route as CrmYtRouteImport } from './routes/crm-yt'
import { Route as DiagnosticoDeAtendimentoEVendasRouteImport } from './routes/diagnostico-de-atendimento-e-vendas'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as EquipeRouteImport } from './routes/equipe'
import { Route as EstruturacaoDeProcessosComerciaisRouteImport } from './routes/estruturacao-de-processos-comerciais'
import { Route as InteligenciaArtificialParaAtendimentoEmpresarialRouteImport } from './routes/inteligencia-artificial-para-atendimento-empresarial'
import { Route as MetodoSvgRouteImport } from './routes/metodo-svg'
import { Route as OtimizacaoFichaGoogleRouteImport } from './routes/otimizacao-ficha-google'
import { Route as PlanoAutoridadeLocalRouteImport } from './routes/plano-autoridade-local'
import { Route as PoliticaDePrivacidadeRouteImport } from './routes/politica-de-privacidade'
import { Route as SeoLocalRouteImport } from './routes/seo-local'
import { Route as SeoNacionalRouteImport } from './routes/seo-nacional'
import { Route as SobreRouteImport } from './routes/sobre'
import { Route as SuporteCrmRouteImport } from './routes/suporte-crm'
import { Route as TermosDeUsoRouteImport } from './routes/termos-de-uso'
import { Route as VendaNoWhatsappMetodoConversaRouteImport } from './routes/venda-no-whatsapp-metodo-conversa'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAcademiaRouteImport } from './routes/admin.academia'
import { Route as AlunoIndexRouteImport } from './routes/aluno.index'
import { Route as AlunoAjudaRouteImport } from './routes/aluno.ajuda'
import { Route as AlunoCursosRouteImport } from './routes/aluno.cursos'
import { Route as AlunoOfertasRouteImport } from './routes/aluno.ofertas'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as ServicosSlugRouteImport } from './routes/servicos.$slug'
import { Route as AdminPostIdRouteImport } from './routes/admin.post.$id'
import { Route as AlunoAulaIdRouteImport } from './routes/aluno.aula.$id'
import { Route as AlunoCursoSlugRouteImport } from './routes/aluno.curso.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AcademiaRoute = AcademiaRouteImport.update({
            id: '/academia',path: '/academia',getParentRoute: () => rootRouteImport
          })
const AlunoRoute = AlunoRouteImport.update({
            id: '/aluno',path: '/aluno',getParentRoute: () => rootRouteImport
          })
const AtendimentoParaAltoVolumeDeContatosRoute = AtendimentoParaAltoVolumeDeContatosRouteImport.update({
            id: '/atendimento-para-alto-volume-de-contatos',path: '/atendimento-para-alto-volume-de-contatos',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AutomacaoComercialRoute = AutomacaoComercialRouteImport.update({
            id: '/automacao-comercial',path: '/automacao-comercial',getParentRoute: () => rootRouteImport
          })
const AutomacaoComercialParaEmpresasRoute = AutomacaoComercialParaEmpresasRouteImport.update({
            id: '/automacao-comercial-para-empresas',path: '/automacao-comercial-para-empresas',getParentRoute: () => rootRouteImport
          })
const AutomacaoComercialParaGrandesEmpresasRoute = AutomacaoComercialParaGrandesEmpresasRouteImport.update({
            id: '/automacao-comercial-para-grandes-empresas',path: '/automacao-comercial-para-grandes-empresas',getParentRoute: () => rootRouteImport
          })
const AutomacaoDeAtendimentoAoClienteRoute = AutomacaoDeAtendimentoAoClienteRouteImport.update({
            id: '/automacao-de-atendimento-ao-cliente',path: '/automacao-de-atendimento-ao-cliente',getParentRoute: () => rootRouteImport
          })
const AutomacaoDeFollowUpRoute = AutomacaoDeFollowUpRouteImport.update({
            id: '/automacao-de-follow-up',path: '/automacao-de-follow-up',getParentRoute: () => rootRouteImport
          })
const AutomacaoDeVendasPeloWhatsappRoute = AutomacaoDeVendasPeloWhatsappRouteImport.update({
            id: '/automacao-de-vendas-pelo-whatsapp',path: '/automacao-de-vendas-pelo-whatsapp',getParentRoute: () => rootRouteImport
          })
const ConsultoriaDeAutomacaoComercialRoute = ConsultoriaDeAutomacaoComercialRouteImport.update({
            id: '/consultoria-de-automacao-comercial',path: '/consultoria-de-automacao-comercial',getParentRoute: () => rootRouteImport
          })
const ContatoRoute = ContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => rootRouteImport
          })
const CriacaoDeSitesRoute = CriacaoDeSitesRouteImport.update({
            id: '/criacao-de-sites',path: '/criacao-de-sites',getParentRoute: () => rootRouteImport
          })
const CriarContaRoute = CriarContaRouteImport.update({
            id: '/criar-conta',path: '/criar-conta',getParentRoute: () => rootRouteImport
          })
const CrmParaWhatsappRoute = CrmParaWhatsappRouteImport.update({
            id: '/crm-para-whatsapp',path: '/crm-para-whatsapp',getParentRoute: () => rootRouteImport
          })
const CrmYtRoute = CrmYtRouteImport.update({
            id: '/crm-yt',path: '/crm-yt',getParentRoute: () => rootRouteImport
          })
const DiagnosticoDeAtendimentoEVendasRoute = DiagnosticoDeAtendimentoEVendasRouteImport.update({
            id: '/diagnostico-de-atendimento-e-vendas',path: '/diagnostico-de-atendimento-e-vendas',getParentRoute: () => rootRouteImport
          })
const EntrarRoute = EntrarRouteImport.update({
            id: '/entrar',path: '/entrar',getParentRoute: () => rootRouteImport
          })
const EquipeRoute = EquipeRouteImport.update({
            id: '/equipe',path: '/equipe',getParentRoute: () => rootRouteImport
          })
const EstruturacaoDeProcessosComerciaisRoute = EstruturacaoDeProcessosComerciaisRouteImport.update({
            id: '/estruturacao-de-processos-comerciais',path: '/estruturacao-de-processos-comerciais',getParentRoute: () => rootRouteImport
          })
const InteligenciaArtificialParaAtendimentoEmpresarialRoute = InteligenciaArtificialParaAtendimentoEmpresarialRouteImport.update({
            id: '/inteligencia-artificial-para-atendimento-empresarial',path: '/inteligencia-artificial-para-atendimento-empresarial',getParentRoute: () => rootRouteImport
          })
const MetodoSvgRoute = MetodoSvgRouteImport.update({
            id: '/metodo-svg',path: '/metodo-svg',getParentRoute: () => rootRouteImport
          })
const OtimizacaoFichaGoogleRoute = OtimizacaoFichaGoogleRouteImport.update({
            id: '/otimizacao-ficha-google',path: '/otimizacao-ficha-google',getParentRoute: () => rootRouteImport
          })
const PlanoAutoridadeLocalRoute = PlanoAutoridadeLocalRouteImport.update({
            id: '/plano-autoridade-local',path: '/plano-autoridade-local',getParentRoute: () => rootRouteImport
          })
const PoliticaDePrivacidadeRoute = PoliticaDePrivacidadeRouteImport.update({
            id: '/politica-de-privacidade',path: '/politica-de-privacidade',getParentRoute: () => rootRouteImport
          })
const SeoLocalRoute = SeoLocalRouteImport.update({
            id: '/seo-local',path: '/seo-local',getParentRoute: () => rootRouteImport
          })
const SeoNacionalRoute = SeoNacionalRouteImport.update({
            id: '/seo-nacional',path: '/seo-nacional',getParentRoute: () => rootRouteImport
          })
const SobreRoute = SobreRouteImport.update({
            id: '/sobre',path: '/sobre',getParentRoute: () => rootRouteImport
          })
const SuporteCrmRoute = SuporteCrmRouteImport.update({
            id: '/suporte-crm',path: '/suporte-crm',getParentRoute: () => rootRouteImport
          })
const TermosDeUsoRoute = TermosDeUsoRouteImport.update({
            id: '/termos-de-uso',path: '/termos-de-uso',getParentRoute: () => rootRouteImport
          })
const VendaNoWhatsappMetodoConversaRoute = VendaNoWhatsappMetodoConversaRouteImport.update({
            id: '/venda-no-whatsapp-metodo-conversa',path: '/venda-no-whatsapp-metodo-conversa',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminAcademiaRoute = AdminAcademiaRouteImport.update({
            id: '/admin/academia',path: '/admin/academia',getParentRoute: () => rootRouteImport
          })
const AlunoIndexRoute = AlunoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AlunoRoute
          })
const AlunoAjudaRoute = AlunoAjudaRouteImport.update({
            id: '/ajuda',path: '/ajuda',getParentRoute: () => AlunoRoute
          })
const AlunoCursosRoute = AlunoCursosRouteImport.update({
            id: '/cursos',path: '/cursos',getParentRoute: () => AlunoRoute
          })
const AlunoOfertasRoute = AlunoOfertasRouteImport.update({
            id: '/ofertas',path: '/ofertas',getParentRoute: () => AlunoRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ServicosSlugRoute = ServicosSlugRouteImport.update({
            id: '/servicos/$slug',path: '/servicos/$slug',getParentRoute: () => rootRouteImport
          })
const AdminPostIdRoute = AdminPostIdRouteImport.update({
            id: '/admin/post/$id',path: '/admin/post/$id',getParentRoute: () => rootRouteImport
          })
const AlunoAulaIdRoute = AlunoAulaIdRouteImport.update({
            id: '/aula/$id',path: '/aula/$id',getParentRoute: () => AlunoRoute
          })
const AlunoCursoSlugRoute = AlunoCursoSlugRouteImport.update({
            id: '/curso/$slug',path: '/curso/$slug',getParentRoute: () => AlunoRoute
          })





const AlunoRouteChildren = {
  AlunoAjudaRoute: AlunoAjudaRoute,AlunoCursosRoute: AlunoCursosRoute,AlunoOfertasRoute: AlunoOfertasRoute,AlunoIndexRoute: AlunoIndexRoute,AlunoAulaIdRoute: AlunoAulaIdRoute,AlunoCursoSlugRoute: AlunoCursoSlugRoute
}

const AlunoRouteWithChildren = AlunoRoute._addFileChildren(AlunoRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AcademiaRoute: AcademiaRoute,AlunoRoute: AlunoRouteWithChildren,AtendimentoParaAltoVolumeDeContatosRoute: AtendimentoParaAltoVolumeDeContatosRoute,AuthRoute: AuthRoute,AutomacaoComercialRoute: AutomacaoComercialRoute,AutomacaoComercialParaEmpresasRoute: AutomacaoComercialParaEmpresasRoute,AutomacaoComercialParaGrandesEmpresasRoute: AutomacaoComercialParaGrandesEmpresasRoute,AutomacaoDeAtendimentoAoClienteRoute: AutomacaoDeAtendimentoAoClienteRoute,AutomacaoDeFollowUpRoute: AutomacaoDeFollowUpRoute,AutomacaoDeVendasPeloWhatsappRoute: AutomacaoDeVendasPeloWhatsappRoute,ConsultoriaDeAutomacaoComercialRoute: ConsultoriaDeAutomacaoComercialRoute,ContatoRoute: ContatoRoute,CriacaoDeSitesRoute: CriacaoDeSitesRoute,CriarContaRoute: CriarContaRoute,CrmParaWhatsappRoute: CrmParaWhatsappRoute,CrmYtRoute: CrmYtRoute,DiagnosticoDeAtendimentoEVendasRoute: DiagnosticoDeAtendimentoEVendasRoute,EntrarRoute: EntrarRoute,EquipeRoute: EquipeRoute,EstruturacaoDeProcessosComerciaisRoute: EstruturacaoDeProcessosComerciaisRoute,InteligenciaArtificialParaAtendimentoEmpresarialRoute: InteligenciaArtificialParaAtendimentoEmpresarialRoute,MetodoSvgRoute: MetodoSvgRoute,OtimizacaoFichaGoogleRoute: OtimizacaoFichaGoogleRoute,PlanoAutoridadeLocalRoute: PlanoAutoridadeLocalRoute,PoliticaDePrivacidadeRoute: PoliticaDePrivacidadeRoute,SeoLocalRoute: SeoLocalRoute,SeoNacionalRoute: SeoNacionalRoute,SobreRoute: SobreRoute,SuporteCrmRoute: SuporteCrmRoute,TermosDeUsoRoute: TermosDeUsoRoute,VendaNoWhatsappMetodoConversaRoute: VendaNoWhatsappMetodoConversaRoute,AdminAcademiaRoute: AdminAcademiaRoute,BlogSlugRoute: BlogSlugRoute,ServicosSlugRoute: ServicosSlugRoute,AdminIndexRoute: AdminIndexRoute,BlogIndexRoute: BlogIndexRoute,AdminPostIdRoute: AdminPostIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)